module.exports = __webpack_public_path__ + "entry-150bfe9b/flaschenpost-photo-001d9a9c8207a0cee76a01ebde0befd5.webp";